import { render } from "./RequestCreditsDialog.vue?vue&type=template&id=ab8ebce6&scoped=true"
import script from "./RequestCreditsDialog.vue?vue&type=script&lang=js"
export * from "./RequestCreditsDialog.vue?vue&type=script&lang=js"

import "./RequestCreditsDialog.vue?vue&type=style&index=0&id=ab8ebce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8ebce6"]])

export default __exports__